export default "__VITE_ASSET__1c39c8af__"